export default __webpack_public_path__ + "static/banner-tab-43f2d0e1b03ddb9fac4817e18d24e664.png";